import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import type { User } from 'firebase/auth';
import { db } from '../firebase';
import type { UserProfile } from '../types';

export function useUserData(user: User | null) {
  const [userData, setUserData] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const uid = user?.uid ?? null;

  useEffect(() => {
    if (!uid) {
      setUserData(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const unsubscribe = onSnapshot(
      doc(db, 'users', uid),
      (snapshot) => {
        setUserData(snapshot.exists() ? (snapshot.data() as UserProfile) : null);
        setLoading(false);
      },
      (err) => {
        setError(err.message || 'Failed to load user data');
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, [uid]);

  return { userData, loading, error };
}
